import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { toolsDetailsBatchConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ToolsDetailsBatchStack = createStackNavigator();

const ToolsDetailsBatchNavigator = () => {
  return (
    <ToolsDetailsBatchStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {toolsDetailsBatchConfig.map(({ Component, name }) => (
        <ToolsDetailsBatchStack.Screen key={name} name={name} component={Component} />
      ))}
    </ToolsDetailsBatchStack.Navigator>
  );
};

export { ToolsDetailsBatchNavigator };
